export const rootPath = () => {
  return window.Shopify?.routes.root || '/';
};

export const origin = () => {
  return `${window.location.host}${rootPath()}`;
};

export default {
  rootPath,
  origin,
};
